(function() { window.GUID_a9926e64_c2f1_4f8d_b3b1_ccd7e10d04f4 = { getGuid: function() { return "a9926e64-c2f1-4f8d-b3b1-ccd7e10d04f4"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-leagueschedule',
                        callback: function (accordion, e) {
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "#dropdown-matches-formats-" + accordion.ContentId,
                                callback: (list, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraValues)
                            });
                        }
                    });
                    function updateFilter(accordion, e, extraData) {
                        CS.Lag('league-schedule-filter', 50, function () {
                            if (extraData != null) {
                                let { url } = extraData;
                                if (url == null)
                                    url = extraData.Url;
                                if (url != null) {
                                    accordion.Data.RefreshUrl = url;
                                    accordion.RefreshContent();
                                }
                            }
                        });
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=league-schedule.js.map
